import './InviteNewBrokerModal.scss';
import React, { useState } from 'react';
import { useStateSelector } from '../../../../../store/selectors';
import Rodal from '../../../../../components/Rodal/Rodal';
import * as yup from 'yup';
import { Form, Field } from '@availity/form';
import createNotification from '../../../../../utils/createNotification';
import Loader from 'react-loaders';

export interface InviteNewBrokerModalProps {
    onClose: () => void;
    isVisible: boolean;
}

interface InviteNewBrokerState {
    name: string;
    email: string;
    affiliation: string;
}

export const InviteNewBrokerModal = (props: InviteNewBrokerModalProps) => {
    const axios = useStateSelector((state) => state.core.axios);
    const [isLoading, setIsLoading] = useState(false);

    const inviteNewBroker = (state: InviteNewBrokerState) => {
        axios
            .post(`api/Marketplace/MarketplaceBrokers`, state)
            .then((response: any) => {
                if (response) {
                    if (response.status === 200) {
                        props.onClose();
                    } else {
                        createNotification(
                            response.response.data.title,
                            'error'
                        );
                    }
                }
            })
            .catch(() => {
                createNotification(
                    'An unexpected error occurred while inviting the broker.',
                    'error'
                );
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const renderForm = () => (
        <Form
            initialValues={{
                name: ``,
                email: '',
                affiliation: '',
            }}
            validationSchema={yup.object().shape({
                name: yup.string().trim().required(),
                affiliation: yup.string().required(),
                email: yup.string().trim().email().required(),
            })}
            onSubmit={(state: InviteNewBrokerState) => {
                const submittedState: InviteNewBrokerState = {
                    name: state.name.trim(),
                    email: state.email.trim(),
                    affiliation: state.affiliation.trim(),
                };
                inviteNewBroker(submittedState);
            }}>
            <div className="d-flex flex-column">
                <div className="form-group row">
                    <div className="col-md-3 d-flex mt-2">
                        <label className="field-label" htmlFor="name">
                            Name:
                        </label>
                    </div>
                    <div className="col-md-9">
                        <Field
                            type="text"
                            name="name"
                            id="name"
                            className="form-control"
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <div className="col-md-3 d-flex mt-2">
                        <label className="field-label" htmlFor="email">
                            Email:
                        </label>
                    </div>
                    <div className="col-md-9">
                        <Field
                            type="email"
                            name="email"
                            id="email"
                            className="form-control"
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <div className="col-md-3 d-flex mt-2">
                        <label className="field-label" htmlFor="affiliation">
                            Affiliation:
                        </label>
                    </div>
                    <div className="col-md-9">
                        <Field
                            type="text"
                            name="affiliation"
                            id="affiliation"
                            className="form-control"
                        />
                    </div>
                </div>

                <div className="mt-auto d-flex justify-content-end">
                    <button
                        type="button"
                        className="btn btn-cancel"
                        onClick={() => props.onClose()}>
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isLoading}>
                        Send Invite
                    </button>
                </div>
            </div>
        </Form>
    );

    const renderLoader = () => {
        return (
            <div className="loader-container" style={{ height: '10vw' }}>
                <div className="loader-container-inner">
                    <div className="text-center">
                        <Loader active={isLoading} type="ball-scale-multiple" />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div>
            <Rodal
                visible={props.isVisible}
                animation="slideTop"
                onClose={() => props.onClose()}
                showMask={false}
                width={600}
                closeOnEsc
                className="modal-invite-new-broker"
                center>
                <div className="modal-header">Invite a New Advisor</div>
                <div className="modal-body">
                    {isLoading ? renderLoader() : renderForm()}
                </div>
            </Rodal>
        </div>
    );
};
